// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 870 ? "c51ae7a0" : chunkId) + "." + {"870":"e76a6a917d72efa2","910":"1119bf2fca4a51b6"}[chunkId] + ".js";
};